module.exports = __webpack_public_path__ + "static/img/error-img.7cbea5ed.png";